// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.
import { redirect } from 'react-router-dom';
import { API_BASE } from '@/config.ts';
import { setCurrentUser, setSessionToken } from '@/stores/auth-store.ts';


export const authGuard = async () => {

  try {
    const response = await fetch(`${API_BASE}/api/auth/session`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem("session_token")}`,
      },
    });
    if (!response.ok) {
      return redirect('/auth/login');
    }

    const contentType = response.headers.get('content-type');
    if (!contentType?.includes('application/json')) {
      return redirect('/auth/login');
    }

    const data = await response.json();

    if (response.ok && data.success) {
      setCurrentUser(data.user);
      setSessionToken(data.sessionToken);
      return data.user;
    }

    return redirect('/auth/login');
  } catch (error) {
    setCurrentUser(null);
    setSessionToken(null);
    throw redirect('/auth/login');
  }
};

export const withAuthGuard = <T = unknown>(
  loader: (args: any) => Promise<T>
) => {
  return async (args: any): Promise<T> => {
    await authGuard();
    return loader(args);
  };
};